export enum ApiType {
  APIM = 'apim',
}
